import { decodeURLParams } from 'helpers/url/cms'
import CONFIG from 'config'

const htmlTime = (date)=> `<time dateTime="${date}" className="datetime">${date}</time>`

export const mapEventCategory = ({ title }) => ({
  label: title,
  value: title
})

export const mapEventDetails = (event, category) => ({
  image: `${CONFIG.CONTENT_CDN_BASE_URL}${event.event_image}`,
  title: event.title,
  description: event.event_description,
  place: event.event_place,
  url: decodeURLParams(event.event_url),
  dates: parseDate(event.event_start_date, event.event_end_date),
  category: category.title,
  id: event.id
})

const parseDate = (startDate, endDate)=> {
  const parseStartDate = startDate && `${ startDate.slice(6,8)}/${startDate.slice(4,6)}/${startDate.slice(0,4)}`
  const parseEndDate = endDate && `${endDate.slice(6,8)}/${endDate.slice(4,6)}/${endDate.slice(0,4)}`
  return `${parseStartDate? htmlTime(parseStartDate):''} ${parseEndDate? '- ' + htmlTime(parseEndDate) : ''}`
}

export const mapEvent = ({ title, event_campaign_id }) => ({
  display: title,
  id: event_campaign_id
})
